import { CloseOutlined } from '@ant-design/icons';

export const CloseIconsForModalWithDataTestId: React.FC = () => {
  return <CloseOutlined data-testid="close-popup" />;
};
